import { API } from '@shared/domain/ume-urls';

const URL = {
  dashboard: '/dashboard',
  company: '/company',
} as const;

export const dashboardUrl = {
  companySummary: (): string => `${API.ver}/public-profile${URL.dashboard}/my-profile`,
  ddqSummary: (): string => `${API.ver}/questionnaire${URL.dashboard}/my-profile`,
  kycMyProfile: (): string => `${API.ver}/kyc${URL.dashboard}/my-profile`,
  kpiMyProfile: (): string => `${API.ver}/kpi${URL.dashboard}/my-profile`,
  policyMyProfile: (): string => `${API.ver}/policy${URL.dashboard}/my-profile`,
  reportingMyProfile: (): string => `${API.ver}/reporting${URL.dashboard}/my-profile`,
  pmKpiMyProfile: (): string => `${API.ver}/reporting/pm-kpi${URL.dashboard}/my-profile`,
  investorProfile: (): string => `${API.ver}/questionnaire/investor${URL.dashboard}/profile`,
  oversightSummary: (): string => `${API.ver + URL.company + URL.dashboard}/oversight`,
  assessmentSummary: (): string => `${API.ver}/assessment${URL.dashboard}`,
  vpSummary: (): string => `${API.ver}/vp${URL.dashboard}`,
  ukcdBanner: (): string => `${API.ver}/reporting/banner`,
  notifications: (): string => `${API.ver}/notifications/home-page-notifications`,
} as const;
